import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  Paper,
  Stack,
  CardContent,
  Chip,
  Divider,
  ChipProps,
  Tooltip,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useGetAllGetOrderListHistoryQuery,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useAdminChangeStatusMutation,
  useGetRestaurantQuery,
  useGetOrderListHistoryRecordByIdQuery,
  useGetStoreQuery,
  useGetStoreItemOrderListQuery,
  useGetCategoryQuery,
  useGetProductQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderItemEdit,
  IOrderList,
  IOrderListHistoryRecord,
  IRestaurant,
  IStore,
  ICategory,
  IUserAdmin,
  IStoreRefItem,
  IVariantView,
} from "../../../Api/Interface/api.interface";
import { Link, useParams } from "react-router-dom";
import {
  OrderListStatus,
  PRIORITY_COLORS,
  SizeOfLevelType,
  beforePriceConfiem,
} from "../../../Core/Enum/enum";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useFormik } from "formik";
import ChecklistRtlRoundedIcon from "@mui/icons-material/ChecklistRtlRounded";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { IoPricetagsOutline } from "react-icons/io5";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import { FcRight } from "react-icons/fc";
import { MdDateRange } from "react-icons/md";
import { TbStatusChange } from "react-icons/tb";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

const ItemList = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1, 2),
  borderRadius: "4px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: "none",

  backgroundColor: selected
    ? theme.palette.primary.main
    : theme.palette.background.paper,

  color: selected ? "#ffffff" : theme.palette.text.primary,

  "& .MuiTypography-root": {
    color: selected ? "#ffffff" : theme.palette.text.primary,
  },

  "&:hover": {
    // boxShadow: theme.shadows[3],
    backgroundColor: selected
      ? theme.palette.primary.dark
      : theme.palette.action.hover,
  },
}));

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    case SizeOfLevelType.lb:
      return "lb";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Purchase Request Draft";
    case "SentToManager":
      return "Purchase Request Pending Approval";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    case "UpdatedStoreOnly":
      return "Updated Store";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const formatUnit = (value: number | string) => {
  const num = Number(value);
  return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
};

const statusColor: Record<string, ChipProps["color"]> = {
  Created: "success",
  Modified: "warning",
  Deleted: "error",
};

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatus: <GrStatusGood color="blue" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
  ChangedExpriDeleiveryDate: <MdDateRange size={17} color="orange" />,
};

const statusMessage: Record<string, string> = {
  ChangedBranch: "Branch changed",
  ChangedStatus: "Status updated",
  ChangedExpriDeleiveryDate: "Deleivery Date updated",
  ChangeBranchandExpDeliveryDate: "Deleivery date and Branch updated",
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const isMobileResLg = useMediaQuery(theme.breakpoints.down("lg"));

  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderItemEdit[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [isPaperVisible, setIsPaperVisible] = useState(true);

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch: orderListRefetch,
  } = useGetAllGetOrderListHistoryQuery({
    orderId: String(orderListHistoryId),
    searchText: "",
  });

  const {
    data: orderListRecordData,
    isLoading: orderListRecordIsLoading,
    isError: orderListRecordIsError,
    refetch: orderListRecordRefetch,
  } = useGetOrderListHistoryRecordByIdQuery({
    perentTableId: String(orderListHistoryId),
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const {
    data: variantData,
    isLoading: variantIsLoading,
    isError: variantIsError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: null,
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newStatus, { isLoading }] = useAdminChangeStatusMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
    id: "",
  });

  const { data: storeRefData, isLoading: storeRefIsLoading } =
    useGetStoreItemOrderListQuery({
      searchText: "",
    });

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderItemEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const getAllStoreRefList = useMemo(() => {
    return storeRefData?.data as IStoreRefItem[];
  }, [storeRefData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const variantList = useMemo(() => {
    return variantData?.data as IVariantView[];
  }, [variantData?.data]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);

  const variantMap = useMemo(() => {
    const map = new Map<
      string,
      {
        name: string;
        displayname: string;
        variantRefNumber: string;
        categoryName: string | null;
      }
    >();

    variantList?.forEach((teamMember) => {
      const categoryName = categoryMap.get(teamMember.categoryId) || null;

      map.set(teamMember.id, {
        name: teamMember.variantName,
        variantRefNumber: teamMember.variantRefNumber,

        displayname: teamMember.variantDisplayName,
        categoryName,
      });
    });

    return map;
  }, [variantList, categoryMap]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const storeRefMap = useMemo(() => {
    const map = new Map();
    getAllStoreRefList?.forEach((category) => {
      map.set(category.id, `${category.referenceNo}`);
    });
    return map;
  }, [getAllStoreRefList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const restaurantMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, category.restaurantsName);
    });
    return map;
  }, [restaurantList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;
  const RestaurantsId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : null;

  const updatedBy =
    orderListDate?.length > 0 ? orderListDate[0].updated_by : null;
  const updatedAt =
    orderListDate?.length > 0 ? orderListDate[0].updated_at : null;
  const expDeliveryDate =
    orderListDate?.length > 0 ? orderListDate[0].expected_delivery_date : null;
  const statusRemark =
    orderListDate?.length > 0 ? orderListDate[0].status_remark : "";

  const handleExportToExcel = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const exportData = orderList.map((row, index) => ({
      "#": index + 1,
      "Ref No": variantMap.get(row.productId)?.variantRefNumber || "",
      Items: row.variantName || "",
      Category: variantMap.get(row.productId)?.categoryName || "",
      Priority: row.priority_status || "",
      Qty: `${formatUnit(row.productTotalUnit)} ${convertUnit(
        row.variantUnit
      )}`,
      Remark: row.remark || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrderList");
    const fileName = `OrderList_${dayjs(createAt).format("YYYY MMM, DD")}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const tableData = orderList.map((row, index) => {
      const itemName = row.variantName || "";
      const remark = row.remark ? `Remark: ${row.remark}` : "";
      const categoryName = variantMap.get(row.productId)?.categoryName || "";
      const variantRefNumber =
        variantMap.get(row.productId)?.variantRefNumber || "";

      return [
        index + 1,
        variantRefNumber,
        remark ? `${itemName}\n${remark}` : itemName,
        categoryName,
        row.priority_status || "",
        `${formatUnit(row.productTotalUnit)} ${convertUnit(row.variantUnit)}`,
      ];
    });
    const tableHeaders = [
      ["#", "Ref No", "Items", "Category", "Priority", "Qty"],
    ];

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);
      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      const leftAlignText = (text: string, y: number) => {
        doc.text(text, 15, y);
      };

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Order List :  ${ReDateId}`, textStartY);

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      rightAlignText(
        `Create By: ${userMap2.get(createBy) || ""}, ${dayjs(createAt).format(
          "YYYY MMM, DD"
        )}`,
        textStartY + 5
      );

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      leftAlignText(
        `${restaurantMap.get(RestaurantsId) || ""} ${convertStatus(
          orderListStatus || ""
        )} `,
        textStartY + 15
      );

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      leftAlignText(
        `Delivery Date : ${dayjs(expDeliveryDate).format("MMM-D, YYYY") || ""}`,
        textStartY + 20
      );

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 25,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `OrderList_${dayjs(createAt).format(
        "YYYY MMM, DD"
      )}.pdf`;

      doc.save(fileName);
    };
  };

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const handleOpenStatusPopup = () => {
    setCoursingToStatus(String(orderListHistoryId));
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(undefined);
    setOpen(false);
  };

  const handleOpenDialogGenerate = () => {
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "ManagerApproved",
      status_remark: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(orderListHistoryId),
          status: values.status,
          status_remark: values.status_remark,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();

  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
        navigate(`/order/list/view/${orderListHistoryId}`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  const coursings: IOrderListHistoryRecord[] = Array.isArray(
    orderListRecordData?.data
  )
    ? (orderListRecordData?.data as IOrderListHistoryRecord[])
    : [];

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  if (
    orderListIsLoading ||
    storeRefIsLoading ||
    storeIsLoading ||
    userIsLoading ||
    OrderListDateIsLoading ||
    categoryLoading ||
    variantIsLoading ||
    restauramtIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={12} sm={12} xs={12}>
        <Card
          className={
            isMobileResLg
              ? classes.orderListLeftCardViewNotHight
              : classes.orderListLeftCardView
          }
        >
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2, borderBottom: 1 }}
            className={classes.orderListLeftHeader}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<TableViewIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportToExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportToPDF}
                  >
                    pdf
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<TbStatusChange style={{ fontSize: "21px" }} />}
                    className={classes.ordeListConfirmButton}
                    onClick={() => {
                      if (orderListStatus === "OrderListCreated") {
                        handleOpenStatusPopup();
                      } else {
                        handleOpenDialogGenerate();
                      }
                    }}
                  >
                    Status
                  </Button>
                </Grid>
                {orderListStatus === "OrderListCreated" && (
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      className={classes.ordeListEditButton}
                      onClick={() => {
                        const path =
                          orderListStatus === "OrderListCreated"
                            ? `/order/list/edit/${orderListHistoryId}`
                            : `/order/list/sentToManager/edit/${orderListHistoryId}`;

                        navigate(path);
                      }}
                    >
                      Edit
                    </Button>
                  </Grid>
                )}
                {orderListStatus === "ManagerApproved" && (
                  <Grid item>
                    <Link
                      to={`/order/list/manual/selection/${orderListHistoryId}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<CheckCircleOutlineOutlinedIcon />}
                        className={classes.ordeListConfirmButton}
                        onClick={() => {
                          navigate(
                            `/order/list/manual/selection/${orderListHistoryId}`
                          );
                        }}
                      >
                        Manual Product Selection
                      </Button>
                    </Link>
                  </Grid>
                )}
                {orderListStatus === "ManagerApproved" && (
                  <Grid item>
                    <Link
                      to={`/order/list/price/admin/edit/${orderListHistoryId}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<ChecklistRtlRoundedIcon />}
                        className={classes.ordeListConfirmButton}
                        onClick={() => {
                          navigate(
                            `/order/list/price/admin/edit/${orderListHistoryId}`
                          );
                        }}
                      >
                        Auto Price Merge List
                      </Button>
                    </Link>
                  </Grid>
                )}

                {orderListStatus === "UpdatedPrice" && (
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      className={classes.ordeListEditButton}
                      onClick={() => {
                        navigate(
                          `/order/list/set/price/edit/${orderListHistoryId}`
                        );
                      }}
                    >
                      Edit Price
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              height: isMobileResLg ? "auto" : "90vh",
              overflow: "auto",
              padding: "2px",
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#eeeeee",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#eeeeee",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#eeeeee",
              },
            }}
          >
            <Grid
              container
              spacing={2}
              my={2}
              px={1}
              sx={{ padding: 2 }}
              className={classes.orderListLeftHeader}
            >
              <Grid item lg={4} md={6} sm={12} xs={12} mb={2}>
                <Grid container spacing={2}>
                  {companyLogo && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <img
                        src={companyLogo}
                        alt="pos"
                        style={{
                          width: "auto",
                          height: "auto",
                          display: "block",
                          cursor: "pointer",
                        }}
                      />
                    </Grid>
                  )}
                  {isMobileRes && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography
                        variant="subtitle1"
                        className={classes.OLCardTitle256}
                      >
                        Order List : {ReDateId}
                      </Typography>
                      {!updatedBy ? (
                        <>
                          <Typography className={classes.OLTypograpyNormal}>
                            {"Created By : "}
                            {userMap.get(createBy) || ""}
                          </Typography>
                          <Typography className={classes.OLTypograpyNormal}>
                            {"Created At : "}
                            {dayjs(createAt).format("MMM-D, YYYY hh:mm A") ||
                              ""}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography className={classes.OLTypograpyNormal}>
                            {"Updated By : "}
                            {userMap.get(updatedBy) || ""}
                          </Typography>
                          <Typography className={classes.OLTypograpyNormal}>
                            {"Updated At : "}
                            {dayjs(updatedAt).format("MMM-D, YYYY hh:mm A") ||
                              ""}
                          </Typography>
                        </>
                      )}
                    </Grid>
                  )}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                      textAlign={"left"}
                      className={classes.OLLeftHeading}
                    >
                      {`${
                        restaurantMap.get(RestaurantsId) || ""
                      } ${convertStatus(orderListStatus || "")} `}
                    </Typography>
                    {expDeliveryDate && (
                      <Typography
                        textAlign={"left"}
                        className={classes.OLLeftHeadingNormal}
                      >
                        {`Delivery Date : ${
                          dayjs(expDeliveryDate).format("MMM-D, YYYY") || ""
                        }`}
                      </Typography>
                    )}

                    {statusRemark && (
                      <Typography className={classes.OLTypograpyNormal}>
                        Remark : {statusRemark}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              {!isMobileRes && (
                <Grid item lg={8} md={6} sm={12} xs={12} mb={2}>
                  <Typography
                    variant="subtitle1"
                    textAlign={"right"}
                    className={classes.OLCardTitle256}
                  >
                    Order List : {ReDateId}
                  </Typography>
                  {!updatedBy ? (
                    <>
                      <Typography
                        textAlign={"right"}
                        className={classes.OLTypograpyNormal}
                      >
                        {"Created By : "}
                        {userMap.get(createBy) || ""}
                      </Typography>
                      <Typography
                        textAlign={"right"}
                        className={classes.OLTypograpyNormal}
                      >
                        {"Created At : "}
                        {dayjs(createAt).format("MMM-D, YYYY hh:mm A") || ""}
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Typography
                        textAlign={"right"}
                        className={classes.OLTypograpyNormal}
                      >
                        {"Updated By : "}
                        {userMap.get(updatedBy) || ""}
                      </Typography>
                      <Typography
                        textAlign={"right"}
                        className={classes.OLTypograpyNormal}
                      >
                        {"Updated At : "}
                        {dayjs(updatedAt).format("MMM-D, YYYY hh:mm A") || ""}
                      </Typography>
                    </>
                  )}
                </Grid>
              )}

              {/* <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  {orderListStatus === "ManagerApproved" && (
                    <Grid item>
                      <ItemList selected={true} onClick={() => handleToggle()}>
                        {!isPaperVisible
                          ? "Back to Products"
                          : "Manual Product Selection"}
                      </ItemList>
                    </Grid>
                  )}
                </Grid>
              </Grid> */}

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell
                                  className={classes.oLTablHeader}
                                  sx={{ width: "5%" }}
                                >
                                  <strong>#</strong>
                                </TableCell>
                                {!isMobileRes && (
                                  <TableCell
                                    className={classes.oLTablHeader}
                                    sx={{ width: "10%" }}
                                  >
                                    <strong>Ref No</strong>
                                  </TableCell>
                                )}
                                <TableCell
                                  className={classes.oLTablHeader}
                                  sx={{ width: "40%", minWidth: "200px" }}
                                >
                                  <strong>Items</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.oLTablHeader}
                                  sx={{ width: "20%" }}
                                >
                                  <strong>Category</strong>
                                </TableCell>
                                {!isMobileRes && (
                                  <TableCell
                                    className={classes.oLTablHeader}
                                    sx={{ width: "10%" }}
                                  >
                                    <strong>Priority</strong>
                                  </TableCell>
                                )}
                                <TableCell
                                  className={classes.oLTablHeader}
                                  sx={{ width: "15%" }}
                                >
                                  <strong>Qty</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {orderListIsLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : orderListIsError ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Typography className={classes.leftORTypo}>
                                      Some thing went to wrong
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : orderList.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Typography className={classes.leftORTypo}>
                                      No data available
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                orderList.map((row: IOrderItemEdit, index) => (
                                  <TableRow
                                    key={index}
                                    className={classes.tableRowHover}
                                    // sx={{
                                    //   backgroundColor: row.isPreviousPaymentPaid
                                    //     ? "#f79aa61c"
                                    //     : "transparent",
                                    // }}
                                  >
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {page * rowsPerPage + index + 1}
                                    </TableCell>
                                    {!isMobileRes && (
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCell}
                                      >
                                        <Typography
                                          className={classes.leftORTypo}
                                        >
                                          {
                                            variantMap.get(row.productId)
                                              ?.variantRefNumber
                                          }
                                        </Typography>
                                      </TableCell>
                                    )}
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Link
                                        to={`/variant/view/${row.productId}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Typography
                                          className={classes.leftORTypo}
                                          sx={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          {row.variantName}
                                        </Typography>
                                        {variantMap.get(row.productId)
                                          ?.variantRefNumber &&
                                          isMobileRes && (
                                            <Typography
                                              className={classes.leftORTypo11}
                                            >
                                              {`Ref No : ${
                                                variantMap.get(row.productId)
                                                  ?.variantRefNumber
                                              }`}
                                            </Typography>
                                          )}
                                        {row.priority_status && isMobileRes && (
                                          <Typography
                                            // className={classes.leftORTypo}
                                            sx={{
                                              fontWeight: 600,
                                              fontSize: "12px",
                                              color:
                                                PRIORITY_COLORS[
                                                  row?.priority_status || ""
                                                ],
                                            }}
                                          >
                                            {row.priority_status}
                                          </Typography>
                                        )}
                                        {row.remark && (
                                          <Typography
                                            className={classes.leftORTypo}
                                            sx={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            {row.remark}
                                          </Typography>
                                        )}
                                      </Link>
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        {
                                          variantMap.get(row.productId)
                                            ?.categoryName
                                        }
                                      </Typography>
                                    </TableCell>
                                    {!isMobileRes && (
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCell}
                                      >
                                        <Typography
                                          // className={classes.leftORTypo}
                                          sx={{
                                            fontWeight: 600,
                                            color:
                                              PRIORITY_COLORS[
                                                row?.priority_status || ""
                                              ],
                                          }}
                                        >
                                          {row.priority_status}
                                        </Typography>
                                      </TableCell>
                                    )}
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        {formatUnit(row.productTotalUnit)}{" "}
                                        {convertUnit(row.variantUnit)}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                ))
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {coursingToStatus && (
            <StatusPopup
              open={open}
              handleCloseDelete={handleCloseStatusPopup}
              onConfirm={async () => {
                await handleChangeStatus(String(orderListHistoryId).toString());
              }}
              title="Management Approval (Purchasing Permission)"
              content={
                <>
                  <Typography sx={{ mb: 1 }}>
                    The following list of items has been submitted for approval.
                  </Typography>

                  <Typography sx={{ mb: 2 }}>
                    By approving this request, you confirm that the listed items
                    and quantities have been reviewed, justified, and approved
                    for procurement.
                  </Typography>

                  <Typography fontWeight={600}>
                    Order ID:{" "}
                    <span style={{ fontWeight: 400 }}>{ReDateId}</span>
                  </Typography>
                </>
              }
            />
          )}

          <Dialog
            open={openOrderListDate}
            onClose={handleCloseDialogGenerate}
            sx={{ padding: 5, minWidth: 450 }}
          >
            <Grid
              className={
                isMobileRes ? classes.DialogMobileBgCard : classes.DialogBgCard
              }
            >
              {" "}
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <form onSubmit={formik.handleSubmit}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.card}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                                Confirm Action
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3} p={"24px"}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Status
                                    <span className={classes.requiedfield}>
                                      *
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    select
                                    size="small"
                                    className={classes.textField}
                                    SelectProps={{
                                      native: false,
                                    }}
                                    defaultValue=""
                                    InputLabelProps={{ shrink: true }}
                                    {...formik.getFieldProps("status")}
                                  >
                                    <MenuItem value="" disabled>
                                      Select some option
                                    </MenuItem>

                                    {Object.entries(beforePriceConfiem).map(
                                      ([key, value], index) => (
                                        <MenuItem key={index} value={value}>
                                          {convertStatus(key)}
                                        </MenuItem>
                                      )
                                    )}
                                  </TextField>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Remark
                                  </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Remark .."
                                    size="small"
                                    multiline
                                    rows={8}
                                    {...formik.getFieldProps("status_remark")}
                                    className={classes.discriptionTextField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                        <Card className={classes.card}>
                          <Grid container spacing={3} p={"24px"}>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={<CloseIcon />}
                                className={classes.addButton}
                                onClick={handleCloseDialogGenerate}
                              >
                                Cancel
                              </Button>
                              <Box m={0.5}></Box>

                              <Button
                                variant="contained"
                                startIcon={
                                  isLoading ? (
                                    <CircularProgress
                                      size={18}
                                      className={classes.isLoading}
                                    />
                                  ) : (
                                    <CheckCircleOutlineIcon />
                                  )
                                }
                                className={classes.addButton}
                                disabled={!formValid || isLoading}
                                onClick={() => formik.handleSubmit()}
                              >
                                Submit
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
        </Card>
      </Grid>

      <Grid item lg={4} md={12} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard2}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2 }}
                className={classes.oLRightHeader}
              >
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Typography className={classes.orderLsitHeadingTypo}>
                        History
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}></Grid>
            </Card>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Box
              sx={{
                height: "100vh",
                overflow: "auto",
                padding: "2px",
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#eeeeee",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#eeeeee",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#eeeeee",
                },
              }}
            >
              <Stack spacing={2}>
                {coursings.map((order, index) => {
                  if (
                    order.order_list_record.length === 0 &&
                    order.activeStatus === "NoChange"
                  )
                    return null;

                  const isLast = index === coursings.length - 1;
                  const userId = isLast ? order.created_by : order.updated_by;
                  const userName = userMap.get(userId) || "";
                  const editeTestFiled = isLast ? "Created By" : "Updated By";

                  return (
                    <Card
                      key={order.id}
                      variant="outlined"
                      className={classes.orderListRightCard2}
                    >
                      <CardContent>
                        <Stack spacing={1} mb={2}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            {/* <FaRegCalendarAlt style={{ color: "#1976d2", fontSize: 18 }} /> */}
                            <Typography variant="h6" fontWeight={600}>
                              {dayjs(order.order_List_created_at).format(
                                "MMM D, YYYY h:mm A"
                              )}
                              {` | ${editeTestFiled} : ${userName}`}
                            </Typography>
                          </Stack>
                        </Stack>
                        {order.activeStatus !== "NoChange" && (
                          <>
                            <Stack spacing={1} mb={2}>
                              <Stack
                                direction="row"
                                // justifyContent="center"
                                // alignItems="center"
                                spacing={1}
                                flexWrap="wrap"
                              >
                                {
                                  statusIcon[
                                    order.activeStatus as keyof typeof statusIcon
                                  ]
                                }

                                <Typography
                                  fontWeight={600}
                                  className={classes.rightORTypoColor}
                                >
                                  <strong>
                                    {statusMessage[
                                      order.activeStatus as keyof typeof statusMessage
                                    ] || "-"}
                                  </strong>
                                </Typography>
                              </Stack>
                              <Stack
                                direction="column"
                                // justifyContent="center"
                                // alignItems="center"
                                spacing={1}
                                flexWrap="wrap"
                              >
                                {(order.activeStatus ===
                                  "ChangeBranchandExpDeliveryDate" ||
                                  order.activeStatus === "ChangedBranch") && (
                                  <div>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      display="flex"
                                      alignItems="center"
                                      gap={0.5}
                                    >
                                      <>
                                        {restaurantMap.get(
                                          order.pre_restaurantsId
                                        ) || ""}
                                        {order.pre_restaurantsId &&
                                          order.restaurantsId && (
                                            <>
                                              <FcRight />
                                            </>
                                          )}
                                        {restaurantMap.get(
                                          order.restaurantsId
                                        ) || ""}
                                      </>
                                    </Typography>
                                  </div>
                                )}

                                {order.activeStatus === "ChangedStatus" && (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    display="flex"
                                    alignItems="center"
                                    gap={0.5}
                                  >
                                    <>
                                      {convertStatus(order.pre_activeStatus)}
                                      {order.pre_activeStatus &&
                                        order.orderListStatus && (
                                          <>
                                            <FcRight />
                                          </>
                                        )}
                                      {convertStatus(order.orderListStatus)}
                                    </>
                                  </Typography>
                                )}
                                {(order.activeStatus ===
                                  "ChangeBranchandExpDeliveryDate" ||
                                  order.activeStatus ===
                                    "ChangedExpriDeleiveryDate") && (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    display="flex"
                                    alignItems="center"
                                    gap={0.5}
                                  >
                                    <>
                                      {order.pre_expected_delivery_date && (
                                        <>
                                          {dayjs(
                                            order.pre_expected_delivery_date
                                          ).format("MMM-D, YYYY")}
                                        </>
                                      )}
                                      {order.pre_expected_delivery_date &&
                                        order.expected_delivery_date && (
                                          <>
                                            <FcRight />
                                          </>
                                        )}
                                      {order.expected_delivery_date && (
                                        <>
                                          {dayjs(
                                            order.expected_delivery_date
                                          ).format("MMM-D, YYYY")}
                                        </>
                                      )}
                                    </>
                                  </Typography>
                                )}
                              </Stack>
                            </Stack>
                          </>
                        )}
                        {order.order_list_record.length > 0 && (
                          <Divider sx={{ mb: 2 }} />
                        )}
                        {order.orderListStatus === "UpdatedPrice" ||
                        order.orderListStatus === "UpdatedStoreOnly" ||
                        order.orderListStatus === "Processed"
                          ? Object.entries(
                              order.order_list_record.reduce((acc, item) => {
                                const key = item.storeId || "unknown";
                                if (!acc[key]) acc[key] = [];
                                acc[key].push(item);
                                return acc;
                              }, {} as Record<string, typeof order.order_list_record>)
                            ).map(([storeId, items]) => {
                              const storeTotal = items.reduce((sum, i) => {
                                return sum + (Number(i.productTotalPrice) || 0);
                              }, 0);

                              return (
                                <Box key={storeId} mb={3}>
                                  {storeId !== "unknown" && (
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      justifyContent="space-between"
                                      sx={{ mb: 1 }}
                                    >
                                      <Typography variant="h5" color="primary">
                                        🏠{" "}
                                        {getStoreMap.get(Number(storeId)) ||
                                          "Unknown Supplier"}
                                      </Typography>
                                    </Stack>
                                  )}

                                  {items.map((item) => (
                                    <Box key={item.id} mb={2} ml={2}>
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                      >
                                        {item.variantName.length > 20 ? (
                                          <Tooltip
                                            title={
                                              <Typography
                                                variant="body2"
                                                sx={{ whiteSpace: "pre-line" }}
                                              >
                                                <strong>
                                                  {item.variantName}
                                                </strong>
                                              </Typography>
                                            }
                                          >
                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              spacing={1}
                                            >
                                              {
                                                statusIcon[
                                                  item.activeStatus as keyof typeof statusIcon
                                                ]
                                              }
                                              <Link
                                                to={`/variant/view/${item.productId}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <Typography
                                                  fontWeight={600}
                                                  className={
                                                    classes.rightORTypoColor
                                                  }
                                                  sx={{
                                                    cursor: "pointer",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                  }}
                                                >
                                                  {item.variantName}
                                                </Typography>
                                              </Link>
                                            </Stack>
                                          </Tooltip>
                                        ) : (
                                          <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={1}
                                          >
                                            {
                                              statusIcon[
                                                item.activeStatus as keyof typeof statusIcon
                                              ]
                                            }
                                            <Link
                                              to={`/variant/view/${item.productId}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Typography
                                                fontWeight={600}
                                                className={
                                                  classes.rightORTypoColor
                                                }
                                                sx={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {item.variantName}
                                              </Typography>
                                            </Link>
                                          </Stack>
                                        )}

                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            flex: 1,
                                            textAlign: "right",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "4px",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          <Box
                                            component="span"
                                            color={
                                              item.activeStatus ===
                                              "priceChanged"
                                                ? "red"
                                                : "#28a745"
                                            }
                                          >
                                            {item.productUnitPrice
                                              ? `$${Number(
                                                  item.productUnitPrice
                                                ).toLocaleString()}`
                                              : "N/A"}
                                          </Box>
                                          <Box component="span" color="#28a745">
                                            *{" "}
                                            {formatUnit(item.productTotalUnit)}
                                          </Box>
                                          <Box component="span" color="#28a745">
                                            {convertUnit(item.variantUnit)}
                                          </Box>
                                          <Box component="span">=</Box>
                                          <Box component="span">
                                            {item.productTotalPrice
                                              ? `$${Number(
                                                  item.productTotalPrice
                                                ).toLocaleString()}`
                                              : "N/A"}
                                          </Box>
                                        </Typography>
                                      </Stack>
                                    </Box>
                                  ))}
                                  {/* {storeId !== "unknown" && (
                                    <Stack
                                      direction="row"
                                      alignItems="right"
                                      justifyContent="right"
                                      sx={{ mb: 1 }}
                                    >
                                      <Typography
                                        variant="h5"
                                        color="primary"
                                        textAlign={"right"}
                                      >
                                        Total: ${storeTotal.toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  )} */}
                                </Box>
                              );
                            })
                          : order.order_list_record.map((item) => (
                              <Box key={item.id} mb={2}>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    {
                                      statusIcon[
                                        item.activeStatus as keyof typeof statusIcon
                                      ]
                                    }
                                    <Link
                                      to={`/variant/view/${item.productId}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Typography
                                        fontWeight={600}
                                        className={classes.rightORTypoColor}
                                        sx={{
                                          cursor: "pointer",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {item.variantName}
                                      </Typography>
                                    </Link>
                                  </Stack>
                                  <Stack
                                    direction="column"
                                    alignItems="end"
                                    spacing={1}
                                  >
                                    {item.pre_productTotalUnit !=
                                      item.productTotalUnit && (
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        display="flex"
                                        alignItems="center"
                                        gap={0.5}
                                      >
                                        {item.pre_productTotalUnit != null &&
                                        item.pre_variantUnit != null ? (
                                          <>
                                            {formatUnit(
                                              item.pre_productTotalUnit
                                            )}{" "}
                                            {convertUnit(item.pre_variantUnit)}
                                            <FcRight />
                                            {formatUnit(
                                              item.productTotalUnit
                                            )}{" "}
                                            {convertUnit(item.variantUnit)}
                                          </>
                                        ) : (
                                          <>
                                            {formatUnit(item.productTotalUnit)}{" "}
                                            {convertUnit(item.variantUnit)}
                                          </>
                                        )}
                                      </Typography>
                                    )}
                                    {item.priority_status !==
                                      item.pre_priority_status && (
                                      <Typography
                                        variant="body2"
                                        display="flex"
                                        alignItems="center"
                                        gap={0.5}
                                        sx={{ fontWeight: 600 }}
                                      >
                                        {item.pre_priority_status != null &&
                                        item.priority_status != null ? (
                                          <>
                                            <span
                                              style={{
                                                color:
                                                  PRIORITY_COLORS[
                                                    item.pre_priority_status
                                                  ],
                                              }}
                                            >
                                              {item.pre_priority_status}
                                            </span>

                                            <FcRight />

                                            <span
                                              style={{
                                                color:
                                                  PRIORITY_COLORS[
                                                    item.priority_status
                                                  ],
                                              }}
                                            >
                                              {item.priority_status}
                                            </span>
                                          </>
                                        ) : (
                                          <span
                                            style={{
                                              color:
                                                PRIORITY_COLORS[
                                                  item.priority_status
                                                ],
                                            }}
                                          >
                                            {item.priority_status}
                                          </span>
                                        )}
                                      </Typography>
                                    )}
                                  </Stack>
                                </Stack>

                                {item.remark && item.remark.length > 100 ? (
                                  <Tooltip
                                    title={
                                      <Typography
                                        variant="body2"
                                        sx={{ whiteSpace: "pre-line" }}
                                      >
                                        <strong>💬 {item.remark}</strong>
                                      </Typography>
                                    }
                                  >
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5, pl: 4 }}
                                    >
                                      💬 {`${item.remark.slice(0, 100)}...`}
                                    </Typography>
                                  </Tooltip>
                                ) : (
                                  item.remark && (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5, pl: 4 }}
                                    >
                                      💬 {item.remark}
                                    </Typography>
                                  )
                                )}
                              </Box>
                            ))}
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Index;
